import { render, staticRenderFns } from "./text-area.vue?vue&type=template&id=de8dcf0e"
import script from "./text-area.vue?vue&type=script&lang=ts"
export * from "./text-area.vue?vue&type=script&lang=ts"
import style0 from "./text-area.vue?vue&type=style&index=0&id=de8dcf0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports